/**
 * AuthCallback - Gère le retour de l'authentification Google OAuth
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Leaf, Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { loginWithGoogle } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Empêcher le double traitement (React StrictMode)
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processGoogleCallback = async () => {
      try {
        // Extraire le session_id du fragment d'URL (#session_id=xxx)
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('[AUTH] Pas de session_id trouvé dans l\'URL');
          navigate('/login', { replace: true });
          return;
        }

        const sessionId = sessionIdMatch[1];
        console.log('[AUTH] Session ID trouvé, échange en cours...');

        // Appeler le backend pour échanger le session_id contre un token
        await loginWithGoogle(sessionId);
        
        console.log('[AUTH] Connexion Google réussie, redirection...');
        // Nettoyer l'URL et rediriger vers le dashboard
        window.history.replaceState({}, document.title, '/');
        navigate('/', { replace: true });
        
      } catch (error) {
        console.error('[AUTH] Erreur lors du callback Google:', error);
        navigate('/login', { replace: true });
      }
    };

    processGoogleCallback();
  }, [navigate, loginWithGoogle]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 via-background to-secondary/5 flex items-center justify-center p-4">
      <div className="flex flex-col items-center gap-6 animate-slide-up">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-xl bg-primary flex items-center justify-center">
            <Leaf className="w-7 h-7 text-primary-foreground" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-foreground">Bureau Agricole</h1>
            <p className="text-sm text-muted-foreground">Numérique</p>
          </div>
        </div>
        
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="w-8 h-8 animate-spin text-primary" />
          <p className="text-muted-foreground text-center">
            Connexion avec Google en cours...
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;
